import { ElementFormatType } from 'lexical';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { Icon, IconButton } from '@socialchorus/shared-ui-components';

const ELEMENT_FORMAT_OPTIONS: Record<string, { icon: string; name: string }> = {
  left: { icon: 'format_align_left', name: 'Left Align' },
  center: { icon: 'format_align_center', name: 'Center Align' },
  right: { icon: 'format_align_right', name: 'Right Align' },
  justify: { icon: 'format_align_justify', name: 'Justify Align' },
};

export default function AlignmentDropdown({
  value,
  onChange,
}: {
  value: ElementFormatType;
  onChange: (format: ElementFormatType) => void;
}) {
  const current =
    ELEMENT_FORMAT_OPTIONS[value || 'left'] || ELEMENT_FORMAT_OPTIONS.left;
  // Left is the default alignment, so highlighting it would leave the control
  // looking permanently pressed. Only an explicit non-default alignment counts.
  const isActive = !!value && value !== 'left';

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <IconButton
          iconName={current.icon}
          title="Text alignment"
          size="extra-compact"
          className={isActive ? 'lexical-toolbar__btn--active' : ''}
        />
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className="lexical-align-dropdown__menu"
          align="start"
          side="top"
        >
          {Object.entries(ELEMENT_FORMAT_OPTIONS).map(([key, opt]) => (
            <DropdownMenu.Item
              key={key}
              className={`lexical-align-dropdown__item${
                (value || 'left') === key
                  ? ' lexical-align-dropdown__item--active'
                  : ''
              }`}
              onSelect={() => onChange(key as ElementFormatType)}
            >
              <Icon size={16}>{opt.icon}</Icon>
              <span>{opt.name}</span>
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
